var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('legend', [_vm._v("Shipment Acknowlegdement and Inscan")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.process),
      expression: "process"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('handovermode')
    },
    attrs: {
      "name": "process",
      "id": "process"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.process = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.ChangeLabelName]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Process")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "InScan"
    }
  }, [_vm._v("InScan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Shortage"
    }
  }, [_vm._v("Shortage")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.process')),
      expression: "errors.has('form-1.process')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Process.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awb),
      expression: "awb"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|VerifyShippingidFormat'),
      expression: "'required|VerifyShippingidFormat'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter ShippingId / AWB",
      "name": "awb",
      "id": "awb"
    },
    domProps: {
      "value": (_vm.awb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awb = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.awb')),
      expression: "errors.has('form-1.awb')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.awb')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "sample-awb-eg col-md-3"
  }, [_vm._v("Maximum 10 shipping IDs permitted for bulk processing.\nMultiple shipping IDs can be separated using comma or  next line (↵/,).")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "size": "sm"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.buttonLabel))]), _vm._v(" \n                "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("\n                  Reset\n                ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isInScanLoader,
      "text": "Please wait shipments is inscan processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.isInScanLoader = $event
      }
    }
  })], 1)])])])])]), _vm._v(" "), ((_vm.returnArray && _vm.returnArray.length != 0)) ? _c('b-card', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTable),
      expression: "showTable"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Agent Handover Process")]), _vm._v(" "), _c('fieldset', [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shippingid")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Message")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.returnArray), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.message))])])
  }), _vm._v(" "), ((_vm.returnArray && _vm.returnArray.length == 0) || _vm.returnArray.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v("No Data found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')])], 1)])])]) : _vm._e()], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Process")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Shippingid ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12cca7ce","hasScoped":true}!./src/views/components/agentinscan/agentinscan.component.html
// module id = 1053
// module chunks = 1